import { langIdOnLocale } from '../../../utils/LocaleUtil/languageList';
import { getCookie } from '../../../utils/CookieUtil';
import { addressFields } from '../../../utils/AddressUtil';

const buildContactPayload = (props) => {
    const {
        emailOptOut,
        // contact information
        titleName, firstName, lastName, latinFirstName, latinLastName, email, locale, password,
        // phone number
        phoneCountryCode, phoneCountryCodeDigits, phoneNumber,
        // property information
        competitorUrl, propertyName, latinPropertyName, currency, propertyType,
        managerInfo, chainInfo, unitCount, websiteUrl,
        // address information
        address, placeId, latLngDetails, partialMatch, isAddressV2, isUnicode,
        // risk details
        fingerprint, useThreeLetterCountryCode,
        // props from the caller
        epcUserId, isPaperContractUser, source, lypsSalesforceExperiment,
        // salesforce information
        submarketId
    } = props;
    const trustPayload = window?.trustApi?.getTrustPayload();
    const langId = langIdOnLocale(locale);
    const type = 'HOTELIER';
    const duaid = getCookie('DUAID');

    const contact = {
        // join details
        type,
        duaid,
        produceAccountCreatedEvent: true,
        source,
        emailOptOut,
        // contact information
        title: titleName,
        firstName,
        lastName,
        latinFirstName,
        latinLastName,
        email,
        locale,
        password,
        epcUserId,
        // phone number
        phoneCountryCode,
        phoneCountryCodeDigits,
        phoneNumber,
        // property information
        competitorUrl,
        propertyName,
        latinPropertyName,
        currency,
        propertyType,
        managerInfo,
        chainInfo,
        unitCount,
        websiteUrl,
        // address information
        parsedAddress: addressFields(address, useThreeLetterCountryCode),
        placeId,
        latLngDetails,
        partialMatch,
        isAddressV2,
        isUnicode,
        // risk details
        langId,
        gaClientId: getCookie('_ga')?.split('.')?.slice(-2)?.join('.'),
        fingerprint,
        trustPayload,
        autoContractSign: isPaperContractUser,
        salesForceFromLyps: lypsSalesforceExperiment === 1,
        salesForceInformation: submarketId ? {
            submarketId
        } : undefined
    };
    return contact;
};

const buildSalesforceInformationPayload = (props) => {
    const {
        address, useThreeLetterCountryCode, latLngDetails,
        unitCount, submarketId
    } = props;
    const request = {
        parsedAddress: addressFields(address, useThreeLetterCountryCode),
        latLngDetails,
        // this is not implemented yet
        lypsIntegration: false,
        unitCount,
        submarketId
    };
    return request;
};
export {
    buildSalesforceInformationPayload,
    buildContactPayload
};
